import React from 'react';
import WeatherDashboard from './WeatherDashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <WeatherDashboard />
    </div>
  );
}

export default App;